<div class="container">
    <div class="row" *ngIf="!isLoading" [ngClass]="{'h-400': multipleFlag, 'h-300': !multipleFlag}">
        <div class="col-xs-12">
            <form #setStatusForm="ngForm" novalidate>
                <div class="row" style="margin-bottom: 10px">
                    <div class="col-xs-12 job-match-status-statement">
                        <div class="main-box" *ngIf="loadingJobMatchesAndPendingItemsDataFlag">
                            <div class="main-box-body">
                                <div class="text-center" style="padding: 20px;">
                                    Loading candidate information <i class="fa fa-spinner fa-spin"></i>
                                </div>
                            </div>
                        </div>
                            <span *ngIf="!multipleFlag && (statusType == 'Not Interested' || statusType == 'Release') && jobMatchesWhoseStatusCanBeSetArray && jobMatchesWhoseStatusCanBeSetArray[0] && !jobMatchesWhoseStatusCanBeSetArray[0].showAlert && !loadingJobMatchesAndPendingItemsDataFlag">
                                Marking the candidate '<span class="emerald">{{jobMatchesWhoseStatusCanBeSetArray[0].jobMatchData.name}}</span>' as '<span class="emerald">{{statusDisplayLabel}}</span>'
                                for the role of '<span class="emerald">{{jobMatchesWhoseStatusCanBeSetArray[0].jobMatchData.jobMatchTitle}}</span>' 
                                <span *ngIf="jobMatchesWhoseStatusCanBeSetArray[0].jobMatchData.jobMatchClientName">at '<span class="emerald">{{jobMatchesWhoseStatusCanBeSetArray[0].jobMatchData.jobMatchClientName}}</span>'</span>
                            </span>
                            <span *ngIf="!multipleFlag && statusType == 'Delete Job Match' && !loadingJobMatchesAndPendingItemsDataFlag && jobMatchesWhoseStatusCanBeSetArray && jobMatchesWhoseStatusCanBeSetArray[0]">
                                '<span class="emerald">Delete job match</span>' of candidate '<span class="emerald">{{jobMatchesWhoseStatusCanBeSetArray[0].jobMatchData.name}}</span>'
                                for the role of '<span class="emerald">{{jobMatchesWhoseStatusCanBeSetArray[0].jobMatchData.jobMatchTitle}}</span>' 
                                <span *ngIf="jobMatchesWhoseStatusCanBeSetArray[0].jobMatchData.jobMatchClientName">at '<span class="emerald">{{jobMatchesWhoseStatusCanBeSetArray[0].jobMatchData.jobMatchClientName}}</span>'</span>
                            </span>
                        <div class="main-box" *ngIf="!multipleFlag && (statusType == 'Not Interested' || statusType == 'Release') && jobMatchesWhoseStatusCanBeSetArray && jobMatchesWhoseStatusCanBeSetArray[0] && jobMatchesWhoseStatusCanBeSetArray[0].showAlert && !loadingJobMatchesAndPendingItemsDataFlag">
                            <div class="main-box-header">
                                 <span>
                                    Marking the candidate '<span class="emerald">{{jobMatchesWhoseStatusCanBeSetArray[0].jobMatchData.name}}</span>' as '<span class="emerald">{{statusDisplayLabel}}</span>'
                                    for role of '<span class="emerald">{{jobMatchesWhoseStatusCanBeSetArray[0].jobMatchData.jobMatchTitle}}</span>' 
                                    <span *ngIf="jobMatchesWhoseStatusCanBeSetArray[0].jobMatchData.jobMatchClientName">at '<span class="emerald">{{jobMatchesWhoseStatusCanBeSetArray[0].jobMatchData.jobMatchClientName}}</span>'</span>
                                </span>
                            </div>
                            <div class="main-box-body" style="height: 120px; overflow-y: auto">
                                <div class="row" *ngFor="let jobMatch of jobMatchesWhoseStatusCanBeSetArray">
                                    <div class="col-xs-12">
                                        <div *ngIf="statusType !== 'Not Interested' && statusType !== 'Release'" [ngClass]="{'bg-info': !jobMatch.showAlert, 'bg-danger': jobMatch.showAlert}" style="margin: 3px; padding: 3px; padding-left: 8px; border-radius: 5px;">
                                            <strong [tooltip]="jobMatch.jobMatchData.name" [adaptivePosition]="false" placement="top"
                                                class="cursor-pointer" [ngClass]="{'emerald': !jobMatch.showAlert, 'red': jobMatch.showAlert}">{{jobMatch.jobMatchData.name}}</strong>
                                            <span [innerHtml]="jobMatch.message"></span>
                                            <span *ngIf="jobMatch.meetingInfoArray.length > 0" class="pointer red fa fa-info-circle ml-2" 
                                                [popoverTitle]="jobMatch.meetingsPopOverTitle"
                                                placement="bottom" [popover]="jobMatchStatusPopoverTemplate" [popoverContext]="{ jobMatch: jobMatch }"
                                                containerClass="set-job-match-status-meeting-details-popover" triggers="mouseenter:mouseleave" [adaptivePosition]="false"
                                                container="body">
                                            </span>
                                        </div>
                                        <div *ngIf="statusType == 'Not Interested' || statusType =='Release'" [ngClass]="{'bg-info': !jobMatch.showAlert, 'bg-danger': jobMatch.showAlert}" style="margin: 3px; padding: 3px; padding-left: 8px; border-radius: 5px;">
                                            <strong [ngClass]="{'emerald': !jobMatch.showAlert, 'red': jobMatch.showAlert}">{{jobMatch.jobMatchData.name}}</strong>
                                            <span [innerHTML]="jobMatch.message"></span>
                                            <span *ngIf="jobMatch.meetingInfoArray.length > 0" class="pointer red fa fa-info-circle ml-2" [popoverTitle]="jobMatch.meetingsPopOverTitle"
                                                placement="bottom" [popover]="jobMatchStatusPopoverTemplate" [popoverContext]="{ jobMatch: jobMatch }"
                                                containerClass="set-job-match-status-meeting-details-popover" triggers="mouseenter:mouseleave"
                                                container="body" [adaptivePosition]="false">
                                            </span> 
                                        </div>
                                        <div  *ngIf="multipleFlag && (statusType == 'Not Interested' || statusType =='Release')" style="display: flex;" [ngClass]="{'has-error': (setStatusForm.submitted && notes.invalid)}">
                                            <label class="control-label" for="reason-{{jobMatch.jobMatchId}}" style="margin:5px;width:70px">
                                                Reason <em>*</em> : 
                                            </label>
                                            <select #notes="ngModel" class="form-control" [name]="'reason-' + jobMatch.jobMatchId" [id]="'reason-' + jobMatch.jobMatchId"
                                                [(ngModel)]="jobMatch.reasonCode" style="width:200px" required>
                                                <option [value]=""></option>
                                                <option *ngFor="let reason of jobMatch.reasonCodesOptions" [ngValue]="reason">
                                                    {{ reason.reason }}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <div class="main-box" *ngIf="multipleFlag && !loadingJobMatchesAndPendingItemsDataFlag && jobMatchesWhoseStatusCanBeSetArray.length > 0">
                            <div class="main-box-header" *ngIf="statusType == 'Release' || statusType == 'Not Interested'">
                                '<span class="emerald">Marking</span>'<span> the following Candidate(s) </span>
                                <span>
                                    as '<span class="emerald">{{statusDisplayLabel}}</span>'
                                    for the role of '<span class="emerald">{{jobMatchesWhoseStatusCanBeSetArray[0].jobMatchData.jobMatchTitle}}</span>'
                                    <span *ngIf="jobMatchesWhoseStatusCanBeSetArray && jobMatchesWhoseStatusCanBeSetArray[0] && jobMatchesWhoseStatusCanBeSetArray[0].jobMatchData.jobMatchClientName">
                                        <span *ngIf="jobMatchesWhoseStatusCanBeSetArray && jobMatchesWhoseStatusCanBeSetArray[0] && jobMatchesWhoseStatusCanBeSetArray[0].jobMatchData.jobMatchClientName">at '<span class="emerald">{{ jobMatchesWhoseStatusCanBeSetArray[0].jobMatchData.jobMatchClientName }}</span>'</span>
                                    </span>
                                </span>
                            </div>
                            <div class="main-box-header" *ngIf="statusType == 'Delete Job Match' && jobMatchesWhoseStatusCanBeSetArray && jobMatchesWhoseStatusCanBeSetArray[0]">
                                '<span class="emerald">Deleting job matches</span>'<span> of the following Candidate(s) </span>
                                <span>
                                    for the role of '<span class="emerald">{{jobMatchesWhoseStatusCanBeSetArray[0].jobMatchData.jobMatchTitle}}</span>'
                                    <span *ngIf="jobMatchesWhoseStatusCanBeSetArray[0].jobMatchData.jobMatchClientName">
                                        <span *ngIf="jobMatchesWhoseStatusCanBeSetArray[0].jobMatchData.jobMatchClientName">at '<span class="emerald">{{ jobMatchesWhoseStatusCanBeSetArray[0].jobMatchData.jobMatchClientName }}</span>'</span>
                                    </span>
                                </span>
                            </div>
                            <div class="main-box-body" style="max-height: 120px; overflow-y: scroll" *ngIf="jobMatchesWhoseStatusCanBeSetArray.length > 0">
                                <div class="row" *ngFor="let jobMatch of jobMatchesWhoseStatusCanBeSetArray">
                                    <div class="col-xs-12" style="display: flex; justify-content: space-between;">
                                        <div class="checkbox-nice" [ngClass]="{'bg-info': !jobMatch.showAlert, 'bg-danger': jobMatch.showAlert}" style="margin: 3px; padding: 3px; padding-left: 8px; border-radius: 5px; display: inline;">
                                            <input type="checkbox" [id]="jobMatch.jobMatchData.id" [name]="jobMatch.jobMatchData.id"
                                                (click)="jobBoardsParameters.onJobBoardSelectionChange()" style="margin:0px"
                                                 [(ngModel)]="jobMatch.selected" />
                                                <label class="control-label" for="{{jobMatch.jobMatchData.id}}">
                                                </label>
                                                <strong class="pl-2 ml-1" [ngClass]="{'emerald': !jobMatch.showAlert, 'red': jobMatch.showAlert}">{{jobMatch.jobMatchData.name}}</strong>
                                                <span [innerHTML]="jobMatch.message"></span>
                                                <!-- <span *ngIf="jobMatch.meetingInfoArray.length > 0" class="pointer">
                                                    <span class="red fa fa-info-circle pl-2" popover="I will hide on blur" triggers="mouseenter:mouseleave"></span>
                                                </span> -->
                                                <span *ngIf="jobMatch.meetingInfoArray.length > 0" class="pointer red fa fa-info-circle ml-2" [popoverTitle]="jobMatch.meetingsPopOverTitle"
                                                      placement="bottom" [popover]="jobMatchStatusPopoverTemplate" [popoverContext]="{ jobMatch: jobMatch }"
                                                      containerClass="set-job-match-status-meeting-details-popover" triggers="mouseenter:mouseleave"
                                                      container="body" [adaptivePosition]="false">
                                                </span>
                                        </div> 
                                        <div  *ngIf="multipleFlag && (statusType == 'Not Interested' || statusType =='Release')" style="display: flex;">
                                            <label class="control-label" for="reason-{{jobMatch.jobMatchId}}" style="margin:5px;width:70px">
                                                Reason <em>*</em>: 
                                            </label>  
                                            <select class="form-control" [name]="'reason-' + jobMatch.jobMatchId" [id]="'reason-' + jobMatch.jobMatchId"
                                                [(ngModel)]="jobMatch.reasonCode" required style="width:200px">
                                                <option *ngFor="let reason of jobMatch.reasonCodesOptions" [ngValue]="reason">
                                                    {{ reason.reason }}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="main-box" *ngIf="multipleFlag && !loadingJobMatchesAndPendingItemsDataFlag && jobMatchesWhoseStatusCannotBeSetArray.length > 0">
                            <div class="main-box-header">
                                '<span class="red">Cannot Mark</span>' the following Candidate(s) as '<span class="red">{{statusDisplayLabel}}</span>' as -
                            </div>
                            <div class="main-box-body" style="max-height: 120px; overflow-y: scroll">
                                <div class="row" *ngFor="let jobMatch of jobMatchesWhoseStatusCannotBeSetArray">
                                    <div class="col-xs-12">
                                        <div [ngClass]="{'bg-info': !jobMatch.showAlert, 'bg-danger': jobMatch.showAlert}" style="margin: 3px; padding: 3px; padding-left: 8px; border-radius: 5px;">
                                            <strong [ngClass]="{'emerald': !jobMatch.showAlert, 'red': jobMatch.showAlert}">{{jobMatch.jobMatchData.name}}</strong>
                                            <span [innerHtml]="jobMatch.message"></span>
                                            <span *ngIf="jobMatch.meetingInfoArray.length > 0" class="pointer red fa fa-info-circle ml-2" [popoverTitle]="jobMatch.meetingsPopOverTitle"
                                                placement="bottom" [popover]="jobMatchStatusPopoverTemplate" [popoverContext]="{ jobMatch: jobMatch }"
                                                containerClass="set-job-match-status-meeting-details-popover" triggers="mouseenter:mouseleave"
                                                container="body" [adaptivePosition]="false">
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <!-- Do not hire -->
                    <div class="col-xs-12 mb-3" *ngIf="!multipleFlag && statusType =='Release'">
                        <div style="display: flex; position: relative; bottom:10px;">
                            <div class="checkbox-nice">
                                <input type="checkbox" id="doNotHire" name="doNotHire"
                                    [(ngModel)]="doNotHire" />
                                <label class="control-label" for="doNotHire">
                                    <span class="text-danger">Do Not Hire Again</span>
                                </label>
                            </div>
                        </div>
                    </div>
                    
                    <!-- Job matches of candidate -->
                    <div class="col-xs-12" *ngIf="doNotHire && jobMatches.length > 0">
                        <div class="panel panel-info">
                            <div class="panel-heading">
                                Current Job Matches of Candidate
                            </div>
                            <div class="panel-body p-0"  style="max-height: 300px; overflow-y: auto;">
                                <table class="table table-bordered table-responsive mb-0">
                                    <thead>
                                        <tr>
                                            <th>Req #</th>
                                            <th>Title</th>
                                            <th>
                                                <span *ngIf="isStaffingCompany">
                                                    Client
                                                </span>
                                                <span *ngIf="!isStaffingCompany">
                                                    BU
                                                </span>
                                            </th>
                                            <th>Recruiter(s)</th>
                                            <th>Current Step</th>
                                            <th>Current State</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let jobMatch of jobMatches">
                                            <td>
                                                <span>{{jobMatch.requisitionNumber}}</span>
                                            </td>
                                            <td>
                                                <span>{{jobMatch.title}}</span>
                                            </td>
                                            <td>
                                                <span>{{jobMatch.clientOrBuOrCorporateName}}</span>
                                            </td>
                                            <td>
                                                <span class="d-block" *ngFor="let recruiterName of jobMatch.recruiterNames">
                                                    {{recruiterName}}
                                                </span>
                                            </td>
                                            <td>
                                                <span>{{jobMatch.currentStep}}</span>
                                            </td>
                                            <td>
                                                <span>{{jobMatch.currentState}}</span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                    <!-- Do not hire for clients -->
                    <div class="form-group mb-0 col-xs-12" *ngIf="doNotHire && isStaffingCompany">
                        <div class="radio col-xs-6 col-md-4">
                            <input type="radio" name="doNotHireAt" id="doNotHireAtClient" [value]="true"
                                [(ngModel)]="doNotHireAtClient" (change)="onDoNotHireAtChange()">
                            <label for="doNotHireAtClient">
                                Clients:
                            </label>
                        </div>
                        <div class="radio col-xs-6 col-md-4 mt-4">
                            <input type="radio" name="doNotHireAt" id="doNotHireAtVendor" [value]="false"
                                [(ngModel)]="doNotHireAtClient"
                                (change)="onDoNotHireAtChange()">
                            <label for="doNotHireAtVendor">
                                {{companyName}}
                            </label>
                        </div>
                        <div class="col-xs-6">
                            <div class="form-group d-inline-block do-not-hire-for-clients">
                                <ng-select
                                    [ngClass]="{'disable-element': !doNotHireAtClient, 'multi-select-error': setStatusForm.submitted && doNotHire && doNotHireAtClient && selectedClients.length == 0}"
                                    name="clients" [items]="clients" dropdownPosition="bottom" placeholder="None selected"
                                    [(ngModel)]="selectedClients" [closeOnSelect]="false" [multiple]="true">
                                    <ng-template ng-option-tmp let-item="item">
                                        <span [innerHtml]="item.name"></span>
                                    </ng-template>
                                    <ng-template ng-header-tmp>
                                        <div class="d-flex">
                                            <div class="mr-2 custom-ng-select-btn" (click)="selectAllClients()">Select All
                                            </div>
                                            <div class="custom-ng-select-btn" (click)="deSelectAllClients()">Select None
                                            </div>
                                        </div>
                                    </ng-template>
                                    <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                                        <div class="ng-value" *ngFor="let item of items | slice:0:1">
                                            <span class="ng-value-label" [innerHtml]="item.name"></span>
                                            <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
                                        </div>
                                        <div class="ng-value" *ngIf="items.length > 1">
                                            <span class="ng-value-label">...({{items.length - 1}})</span>
                                        </div>
                                    </ng-template>
                                </ng-select>
                            </div>
                        </div>
                    </div>

                    <div class="col-xs-4" *ngIf="!multipleFlag && !doNotHire && (statusType == 'Release' || statusType == 'Not Interested') && jobMatchesWhoseStatusCanBeSetArray && jobMatchesWhoseStatusCanBeSetArray[0]">
                        <div class="form-group" [ngClass]="{'has-error': (setStatusForm.submitted && reason.invalid)}">
                            <label class="control-label" for="reason">
                                Reason <em>*</em>: 
                            </label>  
                            <select #reason="ngModel" class="form-control" name="reason" id="reason" required
                                [(ngModel)]="jobMatchesWhoseStatusCanBeSetArray[0].reasonCode">
                                <option *ngFor="let reason of jobMatchesWhoseStatusCanBeSetArray[0].reasonCodesOptions" [ngValue]="reason">
                                    {{ reason.reason }}
                                </option>
                            </select>
                        </div>
                    </div>
                    <div class="col-xs-12">
                        <div class="form-group" [ngClass]="{'has-error': (setStatusForm.submitted && internalNotes.invalid)}">
                            <label for="internalNotes" class="control-label">
                                Internal Notes<em>*</em> :
                            </label>
                            <!-- Voice Input -->
                            <div class="mb-2">
                                <app-voice-input 
                                    (transcriptReady)="onVoiceTranscript($event)"
                                    [sourceScreen]="sourceScreen"
                                    [candidate]="formalizeActivityPayload ? formalizeActivityPayload.candidate : null"
                                    [company]="formalizeActivityPayload ? formalizeActivityPayload.company : null"
                                    [requisition]="formalizeActivityPayload ? formalizeActivityPayload.requisition : null"
                                    [jobMatch]="formalizeActivityPayload ? formalizeActivityPayload.jobMatch : null">
                                </app-voice-input>
                            </div>
                            <textarea #internalNotes="ngModel" name="internalNotes" class="form-control" rows="3"
                                placeholder="Enter your note.." [(ngModel)]="notes" 
                                (change)="onInternalNoteChanged()"
                                required>
                            </textarea>
                            <!-- Formalize Text -->
                            <app-formalize-comment 
                                [inputText]="notes"
                                (outputText)="receiveFormalizedComment($event)"
                                [sourceScreen]="sourceScreen"
                                [candidate]="formalizeActivityPayload ? formalizeActivityPayload.candidate : null"
                                [company]="formalizeActivityPayload ? formalizeActivityPayload.company : null"
                                [requisition]="formalizeActivityPayload ? formalizeActivityPayload.requisition : null"
                                [jobMatch]="formalizeActivityPayload ? formalizeActivityPayload.jobMatch : null">
                            </app-formalize-comment>
                        </div>
                    </div>
                    <div class="col-xs-12" *ngIf="isSharedRequisition">
                        <app-external-notes 
                            [form]="setStatusForm"
                            [note]="notes"
                            [externalNote]="externalNote"
                            [copyNote]="copyNote"
                            (onExternalNoteChange)="onExternalNoteChange($event)"
                            (onCopyNoteChange)="onCopyNoteChange($event)"
                            [sourceScreen]="sourceScreen"
                            [formalizeActivityPayload]="formalizeActivityPayload">
                        </app-external-notes>
                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-12 text-right">
                        <div class="clearfix">
                            <button type="submit" class="btn btn-success" (click)="setJobMatchStatus()" [disabled]="savingFlag || jobMatchesWhoseStatusCanBeSetArray.length == 0">
                                <span *ngIf="!savingFlag && statusType !== 'Delete Job Match'">Save</span>
                                <span *ngIf="savingFlag && statusType !== 'Delete Job Match'">Saving..</span>
                                <span *ngIf="!savingFlag && statusType == 'Delete Job Match'">Delete</span>
                                <span *ngIf="savingFlag && statusType == 'Delete Job Match'">Deleting..</span>
                            </button>
                        </div>
                    </div>
                </div>
            </form>
        </div> 
    </div>

    <div class="row" *ngIf="isLoading">
        <div class="col-xs-12 set-job-match-status-loading-spinner text-center" [ngClass]="{'h-400': multipleFlag, 'h-300': !multipleFlag}">
            <span class="mr-2">Loading</span>
            <span class="fa fa-spinner fa-spin"></span>
        </div>
    </div>
</div>

<ng-template #jobMatchStatusPopoverTemplate let-jobMatch="jobMatch">
    <div>
        <div class="row">
            <div class="col-xs-12">
                <div class="row" class="candidate-job-match-row">
                    <div class="col-xs-4 set-job-match-status-meeting-details-header-text text-overflow-ellipsis">
                        Scheduled Date
                    </div>
                    <div class="col-xs-3 set-job-match-status-meeting-details-header-text text-overflow-ellipsis">
                        Status
                    </div>
                    <div class="col-xs-5 set-job-match-status-meeting-details-header-text text-overflow-ellipsis">
                        {{jobMatch.meetingUserLabel}}
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-xs-12" *ngFor="let meeting of jobMatch.meetingInfoArray">
                <div class="row set-job-match-status-meeting-details-meeting-row">
                    <div class="col-xs-4 text-overflow-ellipsis">{{meeting.startDateTime | fourDotFiveTimeStampFormatPipe}}</div>
                    <div class="col-xs-3 text-overflow-ellipsis">
                        <span class="text-overflow-ellipsis">
                            {{meeting.statusLabel}}
                        </span>
                        <span class="{{meeting.statusClass}}"></span>
                    </div>
                    <div class="col-xs-5 text-overflow-ellipsis">{{meeting.userName}}</div>
                </div>
            </div>
        </div>
    </div>
</ng-template>